module.exports = __webpack_public_path__ + "img/OurServiceDigital_pic1.3d1aeb66.png";